<template>
  <div>
    <!-- 导出 -->
    <Dialog
      class="dialog-padding-container dialog-height-500"
      :width="diaWidth_dc"
      :title="dialogTitle_dc"
      :show="isShowDialog_dc"
      @onCancel="handleCloseDia_dc"
      @onConfirm="diaConfirmBtn_dc"
    >
      <div>
        <h3>导出设置:</h3>
        <el-form
          class="diaForm"
          v-if="isShowDialog_dc"
          ref="dialogFormRef_dc"
          :model="dialogForm_dc"
          label-width="100px"
          label-position="right"
        >
          <el-row :gutter="gutter">
            <el-col :span="span">
              <el-form-item
                required
                class="dialogFormItems"
                prop="fileName"
                label="文件名:"
              >
                <el-input
                  clearable
                  placeholder="请输入(必填)"
                  v-model="dialogForm_dc.fileName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                class="dialogFormItems"
                prop="pageStart"
                label="页码:"
              >
                <el-input
                  clearable
                  placeholder="请输入(选填)"
                  v-model="dialogForm_dc.pageStart"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                class="dialogFormItems"
                prop="pageTotal"
                label="导出条数:"
              >
                <el-input
                  clearable
                  placeholder="(选填),最多20000条"
                  v-model="dialogForm_dc.pageTotal"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="gutter">
            <el-col :span="20">
              <el-form-item
                style="width: auto; padding: 0 10px"
                class="dialogFormItems"
                prop="pageTotal"
                label="导出等待类型:"
              >
                <el-radio-group v-model="dialogForm_dc.EpType">
                  <el-radio label="dd">等待导出完成</el-radio>
<!--                  <el-radio label="bdd"-->
<!--                    >不等待,生成导出记录(到页面右上角查询结果)</el-radio-->
<!--                  >-->
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- <queryCondition
            ref="queryForm"
            :More="isHaseMore"
            :formConfig="queryCondditionDatas"
          ></queryCondition> -->

        <!-- 插槽,插入页面的查询条件 -->
        <h3>查询条件: (同列表页)</h3>


        <h3>表头字段设置</h3>
        <div class="titles_dialog_1">
          <el-checkbox
            class="rowChecks_1"
            label="全选 (导出的Excel表头,可拖动排序)"
            v-model="EPAllCheck"
            @change="checkAll"
          >
          </el-checkbox>
        </div>
        <div style="height: 100%; overflow-y: auto">
          <draggable v-model="epTableHeard2" @end="onAfterEnter">
            <transition-group>
              <div
                class="daraStyle_1"
                v-for="(element, index) in epTableHeard2"
                :key="element.field || index"
              >
                <el-checkbox
                  :true-label="1"
                  :false-label="0"
                  :checked="element.isShow === 1 ? true : false"
                  class="rowChecks_1"
                  label=""
                  v-model="element.isShow"
                  @change="checktab(index, $event)"
                >
                  {{ element.fieldNameShow || element.name }}
                </el-checkbox>
              </div>
            </transition-group>
          </draggable>
        </div>
        <!-- </div> -->
      </div>
    </Dialog>
  </div>
</template>
<script>
import Dialog from "@/components/dialog/index.vue";
// import queryCondition from "@/components/queryCondition.vue";
import draggable from "vuedraggable"; //拖拽组件
export default {
  props: {
    data: Array,
    dialogTitle_dc: {
      typeof: String,
      default: "导出",
    },
    diaWidth_dc: {
      typeof: String,
      default: "50%",
    },
    isShowDialog_dc: {
      typeof: Boolean,
      default: false,
    },
    AllCheck: {
      typeof: Boolean,
      default: false,
    },
    tableHeard: {
      typeof: Array,
      default: [],
    },
    queryType: {
      typeof: String,
      default: "",
    },
    dialogForm_dc: {
      typeof: Object,
      default: function () {
        return {
          pageStart: 1,
          pageTotal: null,
          fileName: null,
          apiName: null,
          EpType: "dd",
          apiType: "GET",
          isJson: 0,
        };
      },
    },
  },
  components: {
    Dialog,
    // queryCondition,
    draggable,
  },
  data() {
    return {
      isHaseMore: true,
      queryCondditionDatas: [], //查询列表动态数据
      // newallCheck: false,
      // selectLength: 0,
      epTableHeard2: [], //
      EPAllCheck: false,
      modelData: {},
      gutter: 20,
      span: 8,
      selectDefaultDocDate: "1",
    };
  },
  watch: {
    AllCheck(a, b) {
      this.EPAllCheck = a;
    },
    tableHeard: {
      handler(a, b) {
        this.epTableHeard2 = a;
        //将isShow的true和false替换为1和0
        this.epTableHeard2.forEach((element, index) => {
          if(element.isShow){
            if(element.isShow === true){
              element.isShow = 1;
            }else if(element.isShow === false){
              element.isShow = 0;
            }
          }
        })
      },
      deep: true,
    },
  },
  created() {},
  mounted() {},
  activated() {},
  destroyed() {},
  methods: {
    // 拖拽后 更新表头数组
    onAfterEnter(e) {
      this.$emit("onAfterEnter", this.epTableHeard2);
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia_dc() {
      this.$emit("handleCloseDia_dc", false);
    },
    //  弹窗确认保存事件
    diaConfirmBtn_dc() {
      this.$emit("diaConfirmBtn_dc");
    },

    checktab(idx, e) {
      console.info('e',e)
      this.$emit("checktabEP", idx, e, this.epTableHeard2);
    },
    checkAll(e) {
      this.$emit("checkAllEP", e, this.epTableHeard2);
    },
    // 默认制单日期
    changeDefaultDocDate(val) {
      modelData["startTime"] = "";
      modelData["endTime"] = "";
    },
  },
};
</script>
<style scoped lang='scss'>
.padding_top {
  padding-top: 10px;
}
// 拖拽
.daraStyle_1 {
  height: 40px;
  line-height: 40px;
  border: 1px solid #d7d7d7;
  padding: 0 10px;
  border-bottom: none;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.daraStyle_1:hover {
  background-color: #f2f2f2;
}

.daraStyle_1:last-of-type {
  border-bottom: 1px solid #d7d7d7;
}

.rowChecks_1 {
  min-width: 120px;
  flex: 1;
}

.sort_templateNames {
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
  position: relative;
}

.sort_templateNames .originBtn {
  position: absolute;
  right: 0;
  // top: -10px;
  padding: 10px;
}

.titles_dialog_1 {
  font-size: 13px;
  color: #666;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px;
}

.dialog-padding-container .diaForm .el-col{
  ::v-deep .el-form-item__content{
    width: 70%;
  }

}
</style>